<template>
<div class="chapter">
<div class="inner_page">
<div id="Part01">
<p class="part-num"><a id="page_9">PART ONE</a></p><a id="page_9">
<p class="part-title"><i>Illustrious</i> Blitz</p>
<p class="page-break">
</p></a><div class="fig"><a id="page_9">
</a><p class="fig-img"><a id="page_9"></a><a id="page_10"><img alt="" class="image" src="images/ufig_10.jpg"/></a></p><a id="page_10">
</a></div><a id="page_10">
<p class="noindent1"> </p>
<div class="fig">
<p class="fig-img"><img alt="" class="image" src="images/ufig_10_1.jpg"/></p>
</div>
</a></div><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Part01.vue?5e51258a